import { login, checkToken } from '../Twitch';

function loginToTwitch() {
  login();
}

export default function LoginButton() {
  document.title = 'Triode tools';
  return (
    <>
      <button onClick={loginToTwitch}>Login to twitch</button>
    </>
  )
}
